'use strict';

module.exports = exports.default = function () {
    $('#showResponsesBtn').off('click').on('click', function () {
        var contestId = $("#Contest_Id").val();
        var date = $("#ResponsesFor").val();
        var onlyWinners = $('#OnlyWinningResponses').prop('checked');

        $("#responsesGrid").DataTable().query(function (x) {
            x.date = date, x.contestId = contestId, x.onlyWinners = onlyWinners;
        });
        $("#responsesGrid").DataTable().ajax.reload(null, false);
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/contestResponses.js
// module id = 423
// module chunks = 0